HuesMdl.service( 'HuesSrv', ['$rootScope', 'PaginationFcty', 'UtilsSrv', '$http', '$q', 'API_URL', function ( $rootScope, PaginationFcty, UtilsSrv, $http, $q, API_URL ) {

	//var filters = {
	//	category: null,
	//	family: null,
	//	color_fan: null,
	//	effect_fan: null,
	//	subcategory: null
	//};



	return new PaginationFcty({

		limit :24,


		filters: {
			category: false,
			family: false,
			color_fan: false,
			effect_fan: false,
			subcategory: false,
			hue: false,
			search_term: false,
			search_single: false
		},

		/**
		 * Array of promises
		 */
		filterQueue: [],


		/**
		 * Each filter is being set by it's own matched controller.
		 * After being set, a defer object is being pushed to the filter queue.
		 * That way we can get hues by filter only after all the filter has been set.
		 * @param filterName
		 * @param filterValue
		 */
		setFilter: function( filterName, filterValue ) {
			var filter = $q.defer();
			this.filters[ filterName ] = filterValue;
			filter.resolve();
			this.filterQueue.push( filter.promise )
		},


		getFilters: function() {
			return this.filters;
		},

		buildFanPath: function( fan ) {
			var path = '/' + fan.replace('_', '-'),
				fan_ids = UtilsSrv.isArray( this.filters[ fan ] ) ? this.filters[ fan ].map(function(fan) {return fan.id}).join(',') : this.filters[ fan ].id ;

			return path + '/' + fan_ids;
		},

		buildQuery: function() {


			var family_path = ( this.filters.family ) ? '/family/' + this.filters.family.id : '',
				color_fan_path = ( this.filters.color_fan ) ? this.buildFanPath( 'color_fan' ) : '',
				effect_fan_path = ( this.filters.effect_fan && ! this.filters.color_fan) ? this.buildFanPath( 'effect_fan' ) : '',
				neutral_fan_path = ( this.filters.effect_fan && this.filters.color_fan ) ? '/neutral-fan/' + this.filters.effect_fan.id : '',
				category_path = ( this.filters.subcategory ) ? '/category/' + this.filters.subcategory : '',
				hue_path = ( this.filters.hue ) ? '/hue/' + this.filters.hue : '',
				search_path = ( this.filters.search_term ) ? '/search-hue/' + this.filters.search_term + '/type/full' : '',
				search_single = ( this.filters.search_single ) ? '/search-hue/' + this.filters.search_single + '/type/single' : '';

			return API_URL.HUE + '/by'+ family_path + effect_fan_path + neutral_fan_path + color_fan_path + category_path + hue_path + search_path + search_single;

		},


		getHues: function() {
			var self = this,
				huePromise = $q.defer();

			this.resetHandlers();


			$q.all(this.filterQueue).then( function(){
				self.API_URL = self.buildQuery();
				self.getResults().then(
					function(hues){
						huePromise.resolve( hues );
					},
					function(error){
						huePromise.reject();
					});
			});

			return huePromise.promise;

		}

	});

}]);
